<template>
  <!-- 数字产服务·农机具二级页面 -->
  <div class="agricultural_planning">
    <div
      v-for="(item, index) in agricultural"
      :key="index"
      class="cont_st"
      @click="click_agricultural()"
    >
      {{ item.cont }}
    </div>
    <!-- 数字服务-农机具 弹框 -->
    <div>
      <el-dialog
        :visible.sync="dialogVisibleTool"
        width="50%"
        :modal="false"
        :close-on-click-modal="false"
        :show-close="false"
        :destroy-on-close="true"
        center
      >
        <span slot="title">
          <img :src="detail_title" alt="" class="dialog-title" />
        </span>
        <img
          :src="detail_icon_one"
          alt=""
          class="close-icon"
          @click="dialogVisibleTool = false"
        />
        <div>
          <Tool />
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Tool from "./details/detail_tool.vue";
export default {
  components: {
    Tool,
  },
  data() {
    return {
      agricultural: [
        {
          cont: "作业数据",
        },
      ],
      // 弹框开关
      dialogVisibleTool: false,
      detail_icon_one: require("@/assets/images/路径 28736_2@2x.png"),
      detail_title: require("@/assets/images/tool.png"),
    };
  },
  methods: {
    load() {
      var height = document.body.clientHeight / 2;
      $(".agricultural_planning").css("top", height + "px");
    },
    click_agricultural() {
      this.dialogVisibleTool = true;
    },
  },
  mounted: function () {
    this.load();
  },
};
</script>

<style scoped lang="less">
.agricultural_planning {
  position: absolute;
  right: 1%;
  // transform: translate(0, -50%);
}
.cont_st {
  cursor: pointer;
  width: 66px;
  height: 30px;
  border: 1px solid #fff;
  margin: 5px 0;
  text-align: center;
  line-height: 30px;
  border-radius: 5px;
  background: url("../../assets/agricultural_planning/经济开发区.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
// 弹框样式
/deep/.el-dialog--center .el-dialog__body {
  padding: 0 18px 20px;
}
/deep/.el-dialog__header {
  padding: 25px 0 26px;
}
/deep/.el-dialog {
  background: #15606e;
  border: 1px solid rgb(43, 249, 252);
}
.close-icon {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 21px;
  right: 41px;
  cursor: pointer;
}
.dialog-title {
  width: 300px;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/cutline/agricultural_tools.vue